import React from "react";
import { UserTimestampContainer, UserName, TimestampText } from "../index.styles";

export const UserTimestamp = ({ userName, action, timestamp }) => {
  return (
    <UserTimestampContainer>
      <UserName>{userName || "System"}</UserName>
      <TimestampText>{timestamp}</TimestampText>
    </UserTimestampContainer>
  );
};
